import React from 'react';
import '../../../css/AddTripForm/Element.css';
import FormField from '../FormField';
import { trekkingDifficultyLevels } from '../../../data/Constants';

const TrekkingElement = ({ data, handleChange }) => {
 const isLinked = data.variants.length > 1;

 const handleIsWithLimitedPlaces = async (field, value) => {
  if (value === false)
  {
    handleChange('capacity', null);
  }
  handleChange(field, value);
}

const handleDurationChange = (field, value) => {
  const hMatch = value.match(/^(\d{1,2})h([0-5]\d)$/);
  if (hMatch) {
    const hours = hMatch[1].padStart(2, '0');
    const minutes = hMatch[2];
    handleChange(field, `${hours}:${minutes}`);
  } else {
    handleChange(field, value);
  }
};

  return (
    <div className="trekkingContainer">
  <FormField
    label="Nazwa"
    name="name"
    type="text"
    value={data.name || ''}
    onChange={(field, value) => handleChange(field, value)}
    placeholder="Podaj nazwę trekkingu"
    required
  />

  <FormField
    label="Opis"
    name="description"
    type="richtext"
    value={data.description || ''}
    onChange={(field, value) => handleChange(field, value)}
    placeholder="Aby użyć link wpisz dowolny tekst (np. Klik) a następnie go zaznacz i wybierz ostatni symbol z paska narzędzi. To pozwoli Ci wpisać link."
  />

  <FormField
    label="Czas rozpoczęcia"
    name="startDate"
    type="datetime-local"
    value={data.startDate || ''}
    onChange={(field, value) => handleChange(field, value)}
    required
  />

<FormField
        label="Czy z limitem miejsc?"
        name="isWithLimitedPlaces"
        type="toggle"
        value={data.isWithLimitedPlaces}
        onChange={(field, value) => handleIsWithLimitedPlaces(field, value)}
      />
    { data.isWithLimitedPlaces && <FormField
        label="Limit miejsc"
        name="capacity"
        type="number"
        min="1"
        step="1"
        value={data.capacity?.toString() || ""}
        onChange={(field, value) => handleChange(field, value)}
        required
      />
    }

  <FormField 
    name="difficulty"
    label="Poziom trudności"
    type="select"
    onChange={(field, value) => handleChange(field, value)}
    options={trekkingDifficultyLevels}
    value={data.difficulty || 0}
    />

  <FormField
    label="Czas przejścia"
    name="duration"
    type="text"
    placeholder="HH:mm lub 5h20"
    value={data.duration ?? ''}
    onChange={(field, value) => handleDurationChange(field, value)}
    pattern="^(([01]?\d|2[0-3]):([0-5]\d)|([0-9]{1,2})h([0-5]\d))$"
    title="Czas przejścia musi być w formacie HH:mm (np. 05:20) lub 5h20 (5 godzin i 20 minut)"
  />

<FormField
    label="Dystans"
    name="distance"
    type="number"
    step="0.1"
    min="0"
    value={data.distance || ''}
    onChange={(field, value) => handleChange(field, value)}
    unit="km"
    placeholder="0,0"
    info="Z dokładnością do pierwszego miejsca po przecinku"
  />

  <FormField
    label="Przewyższenie"
    name="elevation"
    type="number"
    min="0"
    step="1"
    value={data.elevation || ''}
    onChange={(field, value) => handleChange(field, value)}
    unit="m"
    placeholder="123"
    info="Z dokładnością do metrów"
  />

  <FormField
    label="Link"
    name="link"
    type="text"
    value={data.link || ''}
    onChange={(field, value) => handleChange(field, value)}
    placeholder="Podaj link do mapy trekkingu"
  />
</div>


  );
};

export default TrekkingElement;
